module.exports = __webpack_public_path__ + "img/157cb7557ae2db9971513f909126e9c6.png";